'use client';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Button, Textarea } from '@/components/atoms';
import { SelectField } from '../SelectField/SelectField';
import { cn } from '@/lib/utils';
import { useTranslate } from '@tolgee/react';

export const ReportListingForm = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslate();

  const reasonOptions = [
    { label: '', value: '', hidden: true },
    {
      label: t('report_listing_form.trademark_copyright_dmca'),
      value: 'Trademark, Copyright or DMCA Violation',
    },
  ];

  const formSchema = z.object({
    reason: z.string().nonempty(t('report_listing_form.reason_validation_error')),
    comment: z.string().nonempty(t('report_listing_form.comment_validation_error')),
  });

  type FormData = z.infer<typeof formSchema>;

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    setValue,
    clearErrors,
  } = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      reason: '',
      comment: '',
    },
  });

  const onSubmit = (data: FormData) => {
    console.log('Form Data:', data);
  };

  return (
    <div>
      {!isSubmitted ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-4 pb-5">
            <label className="label-sm">
              <p className={cn(errors?.reason && 'text-negative')}>
                {t('report_listing_form.reason_label')}
              </p>
              <SelectField
                options={reasonOptions}
                {...register('reason')}
                selectOption={(value) => {
                  setValue('reason', value);
                  clearErrors('reason');
                }}
                className={cn(errors?.reason && 'border-negative')}
              />
              {errors?.reason && (
                <p className="label-sm text-negative">
                  {errors.reason.message}
                </p>
              )}
            </label>

            <label className="label-sm">
              <p className={cn('mt-5', errors?.comment && 'text-negative')}>
                {t('report_listing_form.comment_label')}
              </p>
              <Textarea
                rows={5}
                {...register('comment')}
                className={cn(errors.comment && 'border-negative')}
              />
              {errors?.comment && (
                <p className="label-sm text-negative">
                  {errors.comment.message}
                </p>
              )}
            </label>
          </div>

          <div className="border-t px-4 pt-5">
            <Button type="submit" className="w-full py-3 uppercase">
              {t('report_listing_form.report_listing_button')}
            </Button>
          </div>
        </form>
      ) : (
        <div className="text-center">
          <div className="px-4 pb-5">
            <h4 className="heading-lg uppercase">{t('report_listing_form.thank_you_heading')}</h4>
            <p className="max-w-[466px] mx-auto mt-4 text-lg text-secondary">
              {t('report_listing_form.thank_you_message')}
            </p>
          </div>

          <div className="border-t px-4 pt-5">
            <Button className="w-full py-3 uppercase" onClick={onClose}>
              {t('report_listing_form.got_it_button')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
